<script lang="ts">
</script>

<footer>
  <section class="footer-inner">
    <h2 class="footer-loogo">
      <img alt="sptr" src="./img/logo_all_white.svg" />
    </h2>
    <ul class="footer-menu">
      <li>
        <a href="#service">サービスについて</a>
      </li>
      <li>
        <a href="#about">スパトレについて</a>
      </li>
      <li>
        <a href="#career">採用情報</a>
      </li>
      <li>
        <a href="#info">お知らせ</a>
      </li>
      <li>
        <a href="mailto:info@sptr.jp">お問い合わせ</a>
      </li>
    </ul>
    <ul class="footer-socialmedia">
      <li>
        <a
          class="footer-navi-link-socialmedia-each"
          href="https://twitter.com/sptrenglish"
        >
          <img alt="twitter" src="./img/twitter_icon.svg" />
        </a>
      </li>
      <li>
        <a
          class="footer-navi-link-socialmedia-each"
          href="https://www.facebook.com/SPTR.english"
        >
          <img alt="facebook" src="./img/facebook_icon.svg" />
        </a>
      </li>
      <li>
        <a
          class="footer-navi-link-socialmedia-each"
          href="https://www.instagram.com/sptr.jp/"
        >
          <img alt="instagram" src="./img/instagram_icon.svg" />
        </a>
      </li>
    </ul>
  </section>
  <section class="copy-right">
    <p>&copy; Spartan English training academy, Inc.</p>
  </section>
</footer>
